import React from "react";

export default function MssStopSign({
  size = 36,
  label = "STOP",
  className = "",
  style = {},
}) {
  const suggested = size * 0.42;             
  const minFont = Math.max(16, size * 0.33);  
  const maxFont = size * 0.25;                
  const fontSize = Math.round(Math.min(Math.max(suggested, minFont), maxFont));

  
  const letterSpacing = Math.round(size * 0.015); // gentler than 0.02

  const octagon =
    "polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%)";

  // Layered approach to avoid white halo (recommended)
  const borderRatio = 0.12; // adjust thickness of the white surround
  const borderSize = Math.round(size * (1 + borderRatio));

  return (
    <div className={className} style={{ position: "relative", width: borderSize, height: borderSize }}>
      {/* White surround (simulated border) */}
      <div
        aria-hidden
        style={{
          position: "absolute",
          inset: 0,
          backgroundColor: "white",
          clipPath: octagon,
          // optional depth
          boxShadow: "0 6px 12px rgba(0,0,0,0.2)",
        }}
      />

      {/* Red stop sign */}
      <div
        className="flex items-center justify-center font-sans font-black uppercase"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: size,
          height: size,
          transform: "translate(-50%, -50%)",
          backgroundColor: "#dc2626", // red-600
          color: "white",
          clipPath: octagon,
          ...style,
        }}
        role="img"
        aria-label={`${label} sign`}
      >
        <span
          style={{
            fontSize,
            letterSpacing,
            lineHeight: 1,
          }}
        >
          {label}
        </span>
      </div>
    </div>
  );
}
